import React from "react";

// Model Layout Component - Gender
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const genderLayers = [
  {
    id: "g0",
    src: "/assets/svgs/gender-svgs/gp0.svg",
    alt: "Gender stack overview",
    style: { left: "52%", top: "63%" },
  },
  {
    id: "g1",
    src: "/assets/svgs/gender-svgs/gp1.svg",
    alt: "Global unpaid care split by gender",
    style: { left: "34%", top: "25%" },
    tooltip: "Gender x Care Economy",
    tooltipPlacement: "right",
  },
  {
    id: "g2",
    src: "/assets/svgs/gender-svgs/gp2.svg",
    alt: "Health implications narrative",
    style: { left: "59%", top: "29%" },
  },
  {
    id: "g3",
    src: "/assets/svgs/gender-svgs/gp3.svg",
    alt: "Unpaid domestic work comparison",
    style: { left: "75%", top: "63%" },
    tooltip: "Gender x Care Economy",
    tooltipPlacement: "left",
  },
  {
    id: "g4",
    src: "/assets/svgs/gender-svgs/gp4.svg",
    alt: "Daily unpaid childcare by women",
    style: { left: "52.8%", top: "93%" },
    tooltip: "Gender x Care Economy",
    tooltipPlacement: "left",
  },
  {
    id: "g5",
    src: "/assets/svgs/gender-svgs/gp5.svg",
    alt: "Country population and unpaid care split",
    style: { left: "27%", top: "83%" },
    tooltip: "Gender x Care Economy",
    tooltipPlacement: "right",
  },
  {
    id: "g6",
    src: "/assets/svgs/gender-svgs/gp6.svg",
    alt: "Hours per day on unpaid care and domestic work",
    style: { left: "30%", top: "56%" },
    tooltip: "Gender x Care Economy",
    tooltipPlacement: "right",
  },
];

const GenderModel = ({ className = "", showTooltips = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      g1: "overview-gender-caregiving",
      g2: "gender-social-determinants-health",
      g3: "india",
      g4: "nepal",
      g5: "indonesia",
      g6: "bangladesh",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[1070/865] max-w-[1100px] ${className}`}
        >
          {genderLayers.map((layer) => {
            const interactive = layer.id !== "g0";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${interactive ? "group" : ""
                  }`}
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className={`select-none object-contain ${interactive
                        ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                        : "pointer-events-none"
                      }`}
                    style={interactive ? { ...hoverTiming } : undefined}
                    {...(interactive ? bounceHandlers : {})}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default GenderModel;
